import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { tokenVerification } from "../commonFunc/verification";
import GlobalURL from "../baseUrl";

const Language = localStorage.getItem('lang');

const initialState = {
  vendorData: [],
  loadingVendors: false,
  errorVendors: null,
};

export const fetchVendors = createAsyncThunk("data/fetchVendors", async () => {
  const token = localStorage.getItem("token");
  const Newtoken = await tokenVerification(token);
  const url = `${GlobalURL}/api/dev/admin/getAllVendors`;
  const headers = {
    "Content-Type": "application/json",
    lang_id: Language,
    token: `${Newtoken}`,
    "ngrok-skip-browser-warning": "69420",
  };
  try {
    const response = await fetch(url, {
      method: "GET", // Use the appropriate HTTP method (GET, POST, etc.)
      headers: headers,
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("Error:", error.message);
  }
});

const dataSlice = createSlice({
  name: "vendors",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendors.pending, (state) => {
        state.loadingVendors = true;
        state.errorVendors = null;
      })
      .addCase(fetchVendors.fulfilled, (state, action) => {
        state.loadingVendors = false;
        state.vendorData = action.payload;
      })
      .addCase(fetchVendors.rejected, (state, action) => {
        state.loadingVendors = false;
        state.errorVendors = action.error.message;
      });
  },
});

export default dataSlice.reducer;
